import React, { useContext, useState, useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { AppContext, getLanguageIntlMessages, languageList } from "@/Context";
import router from "@/router";

// Logo assets - using the existing logo assets
import italicTextLogo from "@/assets/italic_text_logo_black.png";
import logoExtraspace from "@/assets/logo-extraspace.png";

export default function Header() {
  const {
    phone,
    isLoggedIn,
    shipperPhone,
    isShipperLoggedIn,
    currentLanguage,
    setCurrentLanguage,
    onLogout,
    onShipperLogout,
  } = useContext(AppContext);
  
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };
    
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  const changeLanguageEvent = (val) => {
    setCurrentLanguage(getLanguageIntlMessages(val));
  };

  return (
    <header className="w-full h-[72px] bg-gray-light">
        <div className="max-w-7xl mx-auto px-8 h-full flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <img
              src={logoExtraspace}
              alt="ExtraSpace Logo"
              className="h-7"
            />
            <span className="ml-2 text-xs text-gray-500 whitespace-nowrap">by WindPeak</span>
          </div>

          {/* Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            <a href="#" className="text-black text-base">
              免费估价
            </a>
            <a href="/contact-us" className="text-black text-base">
              <FormattedMessage id="nav.link.contact-us" />
            </a>
            <a href="/about-us" className="text-black text-base">
              <FormattedMessage id="nav.link.about-us" />
            </a>
            <div className="flex items-center gap-2">
              <span className="text-black text-base">中文</span>
              <svg width="12" height="6" viewBox="0 0 12 6" fill="none">
                <path
                  d="M10.7148 0.75L6 5.07129L1.28516 0.75H10.7148Z"
                  fill="black"
                  stroke="black"
                />
              </svg>
            </div>
            <a href="#" className="text-black text-base underline">
              登录
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <div className="lg:hidden">
            <div className="w-20 h-[72px] bg-brand-blue flex items-center justify-center">
              <svg width="27" height="18" viewBox="0 0 27 18" fill="none">
                <path
                  d="M25.5767 15C26.3597 15 27.0005 15.6408 27.0005 16.4238V16.5762C27.0005 17.3592 26.3597 18 25.5767 18H1.42236C0.63942 17.9999 0.000488281 17.3591 0.000488281 16.5762V16.4238C0.000488281 15.6409 0.63942 15.0001 1.42236 15H25.5767ZM25.5767 7.5C26.3597 7.5 27.0005 8.14083 27.0005 8.92383V9.07617C27.0005 9.85917 26.3597 10.5 25.5767 10.5H1.42236C0.63942 10.4999 0.000488281 9.85913 0.000488281 9.07617V8.92383C0.000488281 8.14087 0.63942 7.50007 1.42236 7.5H25.5767ZM25.5767 0C26.3597 0 27.0005 0.640828 27.0005 1.42383V1.57617C27.0005 2.35917 26.3597 3 25.5767 3H1.42236C0.63942 2.99993 0.000488281 2.35913 0.000488281 1.57617V1.42383C0.000488281 0.64087 0.63942 6.81742e-05 1.42236 0H25.5767Z"
                  fill="white"
                />
              </svg>
            </div>
          </div>
        </div>
      </header>
  );
}